import React, { useState, useContext } from 'react'
import './login.css'
import { BufferService, M_InputTextField, LoadingContext, M_Button } from '../M_Components'
import { useNavigate } from 'react-router-dom'
import EmailIcon from '@mui/icons-material/Email'
import KeyIcon from '@mui/icons-material/Key'
import ModalChange from './modalChange'
import { IconButton, useMediaQuery } from '@mui/material'

export default function Login({ t }) {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const bufferService = new BufferService('identity/login')
  const [openModalPassword, setOpenModalPassword] = useState(false)
  const ctx = useContext(LoadingContext)
  const navigate = useNavigate()
  const match1 = useMediaQuery('(max-width: 1400px)')
  const match2 = useMediaQuery('(max-width: 1000px)')

  const handleSubmit = () => {
    ctx.setIsLoad(true)
    const user = {
      "email": email,
      "password": password
    }
    bufferService.post(user).then(response => {
      if (response.name === 'AxiosError') {
        ctx.toastMessages('error', response?.response?.data?.Errors ? response.response.data.Errors.toString() : t("AlertMessageBadLogin"))
        ctx.setIsLoad(false)
        return
      }
      if (response.Token === null) {
        ctx.toastMessages("success", "", t("LabelNeedConfirmEmail"))
        ctx.setIsLoad(false)
      }
      else {
        console.log(response)
        ctx.setIsLoad(false)
        localStorage.setItem('tokenMaeil', response.Token)
        ctx.toastMessages("success", "", t("AlertMessageSucessLogged"))
        navigate(`/home`)
      }
    })
  }

  const companyButtons = [
    {
      label: "Devlop Facebook",
      link: "https://www.facebook.com/devlop.systems",
      src: "/icons/socialIcons/Facebook.svg"
    },
    {
      label: "Devlop Instagram",
      link: "https://www.instagram.com/devlop.systems/",
      src: "/icons/socialIcons/Instagram.svg"
    },
    {
      label: "Devlop Linkedin",
      link: "https://www.linkedin.com/company/devlop-systems/mycompany/",
      src: "/icons/socialIcons/Linkedin.svg"
    },
    {
      label: "Devlop Youtube",
      link: "https://www.youtube.com/@devlopsystems",
      src: "/icons/socialIcons/Youtube.svg"
    },
  ]

  const onClickButton = (url) => {
    window.open(url, '_blank')
  }

  return (
    <div style={{ width: '100vw', height: '100vh', overflow: 'hidden', display: 'flex' }}>
      {!match2 && <div style={{ height: '100vh' }}>
        <img src={'/images/BackgroundLogin.jpg'} alt={'Contibérica'} height={'100%'}
          style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto', width: !match1 && '75vw', filter: 'contrast(.7) brightness(1)' }}
        />
      </div>}
      <div style={{
        height: '100vh', backgroundColor: 'white', position: !match2 && 'absolute', right: '0',
        width: !match1 ? '25vw' : match2 && '100vw', display: 'flex', flexDirection: 'column', justifyContent: match2 && 'center', alignItems: 'center'
      }}>
        <div style={{ width: '100%', height: '80%', marginTop: '50px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-evenly' }}>
          <div className='divimage'>
            <img style={{ width: 'auto', height: '250px' }} src='/images/logoWebShot.svg' className='image' alt='Logo_WebSHoT' />
          </div>
          <div className='form' style={{ paddingBottom: '50px' }}>
            <form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
              <M_InputTextField
                noUseState
                iconStart={<EmailIcon style={{ marginRight: '10px', color: 'var(--color-grey)' }} />}
                label={t("textFieldEmailLabel")}
                type="text"
                onChange={e => setEmail(e.target.value)}
              />

              <M_InputTextField
                noUseState
                iconStart={<KeyIcon style={{ marginRight: '10px', color: 'var(--color-grey)' }} />}
                label={t("textFieldPasswordLabel")}
                type="password"
                onChange={e => setPassword(e.target.value)}
              />

              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', marginBottom: '5px' }}>
                <M_Button
                  noHover
                  marginNone
                  label={t("ForgotPassword")}
                  labelColor={"var(--color-black)"}
                  onClick={() => setOpenModalPassword(true)}
                  backgroundColor={"var(--color-white)"}
                  borderColor={"var(--color-white)"}
                />
              </div>

              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                <div style={{ marginBottom: '5px' }}>
                  <M_Button
                    type="submit" // <-- IMPORTANTE
                    width={85}
                    bold
                    label={t("LoginButtonName")}
                    labelColor={'var(--color-white)'}
                    hoverEffect
                    backgroundColor={"var(--color-red-dark)"}
                    borderColor={"var(--color-red-dark)"}
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
        <div style={{ position: 'absolute', bottom: '0', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
          <IconButton style={{ height: '80px', }} disableRipple={true} >
            <img src={`/images/Logo-devlop.png`} alt="logoDevlop" width={'180px'} />
          </IconButton>
          <div style={{ bottom: '0', display: 'flex', justifyContent: 'center', height: '50px', width: '100%', backgroundColor: 'var(--color-white)' }}>
            <div style={{ display: 'flex', }}>
              {companyButtons.map((el, i) => (
                <div key={i} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <M_Button
                    backgroundColor={"transparent"}
                    tooltip={el.label}
                    hoverEffect={false}
                    none
                    icon={<img src={el.src} alt={el.label} color='red' className={el.className}
                      style={{ width: '20px', filter: 'invert(25%) sepia(34%) saturate(6205%) hue-rotate(349deg) brightness(86%) contrast(100%)' }}
                    />}
                    onClick={() => onClickButton(el.link)}
                  />
                  {el.label === "Devlop Linkedin" && <div style={{ fontSize: '12px', fontWeight: 'bold' }}> devlop.systems </div>}
                  {el.label === "Devlop Youtube" && <div style={{ fontSize: '12px', fontWeight: 'bold' }}> @devlopsystems </div>}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <ModalChange openModalPassword={openModalPassword} setOpenModalPassword={setOpenModalPassword} />
    </div>
  )
}